/**
 * Phase 2 Deploy (Pattern A) — hostname-aware route gating.
 *
 * PorchLight runs at three hostnames in the wild:
 *   • theporchlight.io           → the SaaS marketing/signup site for agents
 *   • sellwitherika.com          → Erika Cannon's personal seller portal
 *   • <agent>.example.com or
 *     theporchlight.io/<slug>/   → a tenant agent's white-labeled portal
 *
 * Agent-facing pages (`/for-agents`, `/signup`) belong to theporchlight.io.
 * On sellwitherika.com or any white-labeled tenant host, those routes should
 * be silently redirected to the seller-side root so visitors don't land on
 * "Sign up to be a real estate agent" content that's not relevant to them.
 *
 * Preview pods and localhost are treated permissively (everything renders)
 * so we can demo and develop without flipping env vars.
 */

const MARKETING_HOSTS = ["theporchlight.io", "www.theporchlight.io"];
// Hosts on which agent-facing marketing/signup routes should NOT render.
const SELLER_ONLY_HOSTS = ["sellwitherika.com", "www.sellwitherika.com"];

export function getHost() {
  if (typeof window === "undefined") return "";
  return (window.location.hostname || "").toLowerCase();
}

export function isMarketingHost() {
  return MARKETING_HOSTS.includes(getHost());
}

export function isSellerOnlyHost() {
  return SELLER_ONLY_HOSTS.includes(getHost());
}

/** True when agent-facing routes (/for-agents, /signup) should be allowed. */
export function agentMarketingAllowed() {
  // Block on hosts we know belong to a single agent (e.g. sellwitherika.com).
  // Allow everywhere else (theporchlight.io, preview pods, localhost).
  return !isSellerOnlyHost();
}
